// removed by extract-text-webpack-plugin
module.exports = {"empty":"empty__3CRhE","loading":"loading__iwtDc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Nvl/styles.scss
// module id = 2137
// module chunks = 1